<template>
  <div v-if="show" class="modal-overlay" @click="close">
    <div class="modal-content-wrapper" @click.stop>
      <div class="modal-content">
        <div class="text-content-modal text-center">
          <div class="col-12">
            <div class="bold-text option-name">
              <span>{{ option.name }}</span>
            </div>
          </div>
          <div class="col-12">
            <div class="text-therapist-booking bold-text">
              <span>{{ option.timeunit }} 分</span>
              <span v-if="option.unitprice">{{ numberWithDelimiter(option.unitprice) }} (税込)</span>
            </div>
          </div>
        </div>
        <div>
          <div v-if="option.timeprice_option_image && option.timeprice_option_image.url" class="img text-center mt-4">
            <img :src="option.timeprice_option_image.url" class="height-160" />
          </div>
          <div v-else-if="option.timeprice_image && option.timeprice_image.url" class="img text-center mt-4">
            <img :src="option.timeprice_image.url" class="height-160" />
          </div>
          <div class="mt-4 mb-4 menu_explain-booking" v-html="formattedOptionExplain"></div>
          <div class="text-center">
            <span class="close-modal-timeprice font-family-W3" @click="close">閉じる</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    option: {
      type: Object,
      required: true
    }
  },
  watch: {
    show(type) {
      if (type) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }
  },
  computed: {
    formattedOptionExplain() {
      if (this.option.timeprice_option_explain) {
        return this.option.timeprice_option_explain.replace(/\r\n/g, '<br/>');
      } else if (this.option.menu_explain) {
        return this.option.menu_explain.replace(/\r\n/g, '<br/>');
      }
      return '';
    }
  },
  methods: {
    close() {
      document.body.classList.remove('no-scroll');
      this.$emit('close');
    },
    numberWithDelimiter(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  padding: 3rem;
}

.modal-content-wrapper {
  background: white;
  border-radius: 10px;
  max-width: 800px;
  width: 100%;
  overflow: hidden;
}

.modal-content {
  padding: 20px 14px;
  width: 100%;
  font-family: "HiraginoSans-W3";
  max-height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;
}

.text-content-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.height-160 {
  height: 160px;
}
</style>
